<template>
  <Modal
    :value="value"
    v-on="$listeners"
    :title="selected.chocoPackage.Title"
    :subtitle="`${nameAndVersion.name} - ${nameAndVersion.version}`"
  >
    <template v-if="selected.stats" slot="body" class="content">
      <Chart
        class="margin-bottom-1"
        :data="{
          points: [
            selected.stats.totalWorking,
            selected.stats.totalInstalled,
            selected.stats.totalUninstalled,
            selected.stats.totalFailed,
            selected.stats.totalNoStatus
          ],
          labels: ['Working', 'Installed', 'Uninstalled', 'Failed', 'No status']
        }"
      ></Chart>

      <div class="tabs">
        <ul>
          <li :class="{ 'is-active': tab === 2 }" @click="setTab(2)">
            <a>
              <span class="margin-right-5">Working</span>
              <span v-show="selected.stats.totalWorking !== 0" class="is-size-7"
                >({{ selected.stats.totalWorking }})</span
              >
            </a>
          </li>
          <li :class="{ 'is-active': tab === 3 }" @click="setTab(3)">
            <a>
              <span class="margin-right-5">Installed</span>
              <span
                v-show="selected.stats.totalInstalled !== 0"
                class="is-size-7"
                >({{ selected.stats.totalInstalled }})</span
              >
            </a>
          </li>
          <li :class="{ 'is-active': tab === 4 }" @click="setTab(4)">
            <a
              ><span class="margin-right-5">Uninstalled</span>
              <span
                v-show="selected.stats.totalUninstalled !== 0"
                class="is-size-7"
                >({{ selected.stats.totalUninstalled }})</span
              >
            </a>
          </li>
          <li :class="{ 'is-active': tab === 5 }" @click="setTab(5)">
            <a>
              <span class="margin-right-5">Failed</span>
              <span v-show="selected.stats.totalFailed !== 0" class="is-size-7"
                >({{ selected.stats.totalFailed }})</span
              >
            </a>
          </li>
          <li :class="{ 'is-active': tab === 6 }" @click="setTab(6)">
            <a>
              <span class="margin-right-5">No status</span>
              <span
                v-show="selected.stats.totalNoStatus !== 0"
                class="is-size-7"
                >({{ selected.stats.totalNoStatus }})</span
              >
            </a>
          </li>
        </ul>
      </div>

      <div v-if="selected.stats[prop] && selected.stats[prop].length === 0">
        <i class="text-small">No computers</i>
      </div>

      <div
        class="columns is-multiline"
        v-if="
          selected.stats &&
            selected.stats[prop] &&
            selected.stats[prop].length !== 0
        "
      >
        <div class="column is-12">
          <div class="columns is-multiline extrapadding">
            <div
              class="is-unselectable truncate column is-6 is-marginless is-paddingless"
              v-for="computer of selected.stats[prop]"
              :key="computer.uid"
            >
              <router-link
                :to="
                  `/domains/${$route.params.domainUID}/computers/${computer.uid}/packages`
                "
              >
                <span class="margin-right-5">
                  {{ computerName(computer) }}</span
                >
                <span
                  v-if="computer.online"
                  class="dot has-background-success"
                ></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer" class="content">
      <div class="button" @click="hide()">Close</div>
    </template>
  </Modal>
</template>

<style lang="css" scoped>
.test {
  -webkit-appearance: none;
  border: none;
  border-radius: 290486px;
  display: block;
  height: 1rem;
  overflow: hidden;
  padding: 0;
  width: 100%;
}
</style>

<script>
import { getPackageNameVersionAndHash } from "@/utils/mdc";
import computerHelpers from "@/utils/computer";

export default {
  props: { value: Boolean, item: Object, tab: Number },
  components: {
    Modal: () => import("./Modal"),
    Chart: () => import("@/components/main/group/Chart.vue")
  },
  data() {
    return {
      isLoading: false,
      prop: null
    };
  },
  computed: {
    selected() {
      return this.$store.getters["groupPackage/mergedPackage"](this.item);
    },
    nameAndVersion() {
      return getPackageNameVersionAndHash(this.item);
    },
    computerName() {
      return computer => {
        return computerHelpers.getName(computer);
      };
    }
  },
  created() {
    this.setTab(this.tab);
  },
  methods: {
    hide() {
      this.$emit("input", false);
    },
    setTab(tab) {
      switch (tab) {
        case 1:
          if (
            this.selected.command &&
            this.selected.command.name &&
            this.selected.command.name !== "uninstall"
          ) {
            this.prop = "installedComputers";
            this.$emit("changed", 3);
          } else if (
            this.selected.command &&
            this.selected.command.name &&
            this.selected.command.name === "uninstall"
          ) {
            this.prop = "uninstalledComputers";
            this.$emit("changed", 4);
          } else {
            this.prop = "installedComputers";
            this.$emit("changed", 3);
          }
          break;
        case 2:
          this.$emit("changed", 2);
          this.prop = "workingComputers";
          break;
        case 3:
          this.$emit("changed", 3);
          this.prop = "installedComputers";
          break;
        case 4:
          this.$emit("changed", 4);
          this.prop = "uninstalledComputers";
          break;
        case 5:
          this.$emit("changed", 5);
          this.prop = "failedComputers";
          break;
        case 6:
          this.$emit("changed", 6);
          this.prop = "noStatusComputers";
          break;
      }
    }
  }
};
</script>
